/* AUTAVEX — накидки: кольори та фото за узором */
window.AV_NK_COLS={
 '\u0412\u0435\u043b\u0438\u043a\u0438\u0439 \u0440\u043e\u043c\u0431':[
  ['\u0421\u0432\u0456\u0442\u043b\u043e-\u0431\u0435\u0436\u0435\u0432\u0438\u0439','#DCCFB4','IMG-3938.jpg?v=1786524644'],
  ['\u0411\u0435\u0436\u0435\u0432\u0438\u0439','#CDB595','IMG-3937.jpg?v=1786524644'],
  ['\u0421\u0432\u0456\u0442\u043b\u043e-\u043a\u043e\u0440\u0438\u0447\u043d\u0435\u0432\u0438\u0439','#A07850','IMG-3942.jpg?v=1786524644'],
  ['\u041a\u043e\u0440\u0438\u0447\u043d\u0435\u0432\u0438\u0439','#6B4A33','IMG-3941.jpg?v=1786524644'],
  ['\u0421\u0456\u0440\u0438\u0439','#7E8388','IMG-3944.jpg?v=1786524644'],
  ['\u0422\u0435\u043c\u043d\u043e-\u0441\u0456\u0440\u0438\u0439','#4C5053','508EA63C-BFB5-4211-B792-8863A4D797F0.jpg?v=1786524518'],
  ['\u0427\u043e\u0440\u043d\u0438\u0439','#1F2123','IMG-3935.jpg?v=1786524644'],
  ['\u0427\u043e\u0440\u043d\u0438\u0439 \u0437 \u0431\u0456\u043b\u0438\u043c','#2B2D2F','IMG-3934.jpg?v=1786524644'],
  ['\u0427\u043e\u0440\u043d\u0438\u0439 \u0437 \u0441\u0438\u043d\u0456\u043c','#20293A','IMG-3939.jpg?v=1786524644'],
  ['\u0427\u043e\u0440\u043d\u0438\u0439 \u0437 \u0447\u0435\u0440\u0432\u043e\u043d\u0438\u043c','#3A1D20','IMG-3940.jpg?v=1786524644']
 ],
 '\u0414\u0440\u0456\u0431\u043d\u0438\u0439 \u0440\u043e\u043c\u0431':[
  ['\u0421\u0432\u0456\u0442\u043b\u043e-\u0431\u0435\u0436\u0435\u0432\u0438\u0439','#DCCFB4','IMG-3911.jpg?v=1786522014'],
  ['\u0411\u0435\u0436\u0435\u0432\u0438\u0439','#CDB595','IMG-3916.jpg?v=1786522014'],
  ['\u0420\u0443\u0434\u0438\u0439','#A9541F','IMG-3913.jpg?v=1786522014'],
  ['\u0427\u0435\u0440\u0432\u043e\u043d\u0438\u0439','#A8232B','IMG-3914.jpg?v=1786522014'],
  ['\u0411\u043e\u0440\u0434\u043e\u0432\u0438\u0439','#6E2733','IMG-3918.jpg?v=1786522014'],
  ['\u0422\u0435\u043c\u043d\u043e-\u0441\u0456\u0440\u0438\u0439','#4C5053','IMG-3915.jpg?v=1786522014'],
  ['\u0427\u043e\u0440\u043d\u0438\u0439','#1F2123','IMG-3921.jpg?v=1786522014'],
  ['\u0427\u043e\u0440\u043d\u0438\u0439 \u0437 \u0431\u0456\u043b\u0438\u043c','#2B2D2F','IMG-3917.jpg?v=1786522014'],
  ['\u0427\u043e\u0440\u043d\u0438\u0439 \u0456 \u0441\u0438\u043d\u044f \u043d\u0438\u0442\u043a\u0430','#20293A','IMG-3919.jpg?v=1786522014'],
  ['\u0427\u043e\u0440\u043d\u0438\u0439 \u0456 \u0447\u0435\u0440\u0432\u043e\u043d\u0430 \u043d\u0438\u0442\u043a\u0430','#3A1D20','IMG-3920.jpg?v=1786522014']
 ],
 '\u0421\u043e\u0442\u0430':[
  ['\u0421\u0432\u0456\u0442\u043b\u043e-\u0431\u0435\u0436\u0435\u0432\u0438\u0439','#DCCFB4','FullSizeRender_006017ca-b9e5-467e-9119-d2c6e3fb4a29.jpg?v=1786523427'],
  ['\u0422\u0435\u043c\u043d\u043e-\u0431\u0435\u0436\u0435\u0432\u0438\u0439','#C0A47E','IMG-3954.jpg?v=1786524955'],
  ['\u0421\u0432\u0456\u0442\u043b\u043e-\u043a\u043e\u0440\u0438\u0447\u043d\u0435\u0432\u0438\u0439','#A07850','IMG-3955.jpg?v=1786524955'],
  ['\u041a\u043e\u0440\u0438\u0447\u043d\u0435\u0432\u0438\u0439','#6B4A33','IMG-3956.jpg?v=1786524955'],
  ['\u0411\u043e\u0440\u0434\u043e\u0432\u0438\u0439','#6E2733','IMG-3953.jpg?v=1786524955'],
  ['\u0421\u0456\u0440\u0438\u0439','#7E8388','IMG-3958.jpg?v=1786525209'],
  ['\u0427\u043e\u0440\u043d\u0438\u0439','#1F2123','IMG-3949.jpg?v=1786524955'],
  ['\u0427\u043e\u0440\u043d\u0438\u0439 \u0437 \u0431\u0456\u043b\u0438\u043c','#2B2D2F','IMG-3951.jpg?v=1786524955'],
  ['\u0427\u043e\u0440\u043d\u0438\u0439 \u0456 \u0441\u0438\u043d\u044f \u043d\u0438\u0442\u043a\u0430','#20293A','IMG-3957.jpg?v=1786525210'],
  ['\u0427\u043e\u0440\u043d\u0438\u0439 \u0437 \u0447\u0435\u0440\u0432\u043e\u043d\u0438\u043c','#3A1D20','IMG-3950.jpg?v=1786524955']
 ]
};
/* фото для карток узору */
window.AV_NK_DZPIC={
 '\u0412\u0435\u043b\u0438\u043a\u0438\u0439 \u0440\u043e\u043c\u0431':'F1105687-BDA6-4661-82C9-7209DFE2DE93.jpg?v=1786523421',
 '\u0414\u0440\u0456\u0431\u043d\u0438\u0439 \u0440\u043e\u043c\u0431':'IMG-3921.jpg?v=1786522014',
 '\u0421\u043e\u0442\u0430':'FullSizeRender_006017ca-b9e5-467e-9119-d2c6e3fb4a29.jpg?v=1786523427'
};
/* додаткові фото в галерею (без кружечка) */
window.AV_NK_EXTRA={
 '\u0414\u0440\u0456\u0431\u043d\u0438\u0439 \u0440\u043e\u043c\u0431':[
  'IMG-3933.jpg?v=1786524129','IMG-3932.jpg?v=1786524128','IMG-3931.jpg?v=1786524128',
  'IMG-3930.jpg?v=1786524129','IMG-3928.jpg?v=1786524128'
 ],
 '\u0412\u0435\u043b\u0438\u043a\u0438\u0439 \u0440\u043e\u043c\u0431':[
  'IMG-3947.jpg?v=1786524813','IMG-3946.jpg?v=1786524812',
  '66654D34-0442-4134-8C00-6EDD6FF9125B.jpg?v=1786524845',
  'B93961EB-494B-41C7-94B7-DE2A3C8C91DF.jpg?v=1786524845'
 ],
 '\u0421\u043e\u0442\u0430':[
  'IMG-3964.jpg?v=1786525313','IMG-3963.jpg?v=1786525313','IMG-3962.jpg?v=1786525312',
  'IMG-3961.jpg?v=1786525313','IMG-3960.jpg?v=1786525313'
 ]
};
